<template>
    <svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">

        <title>

        </title>
        <g id="radar-base">

            <polygon v-for="p in baseFrame" :points="p.points" :key="p.id"  :class="{'last':p.isLast}"></polygon>

            <!-- <circle :cx="circle.cx" :cy="circle.cy" :r="circle.r"></circle> -->
        </g>

        <g id="radar-pentagon">
            <polygon :points="points"></polygon>
            <text v-for="point in axisLabelPoints" :key="point.id" :x="point.x" :y="point.y" dx="-3" dy="3">{{point.label}}</text>
        </g>

    </svg>
</template>
<script>
import Common from "@/components/Common";
export default {
    mixins:[Common],
    components: {
    },
    props: {
      values:{
        type:Array,
        required: true,
      }
    },
    watch: {
      'values':function (){
        this.refresh();
      },
    },
    data: () => ({
        circle:{
            cx: 100, cy: 100, r: 80
        },
        stats:[
            {
                "label": "技術",
                "value": 80,
                "id": 0
            },
            {
                "label": "品質",
                "value": 90,
                "id": 1
            },
            {
                "label": "納期",
                "value": 100,
                "id": 2
            },
            {
                "label": "人柄",
                "value": 70,
                "id": 3
            },
            {
                "label": "将来",
                "value": 100,
                "id": 4
            },
            {
                "label": "価格",
                "value": 100,
                "id": 5
            }
        ],

        baseFrame:[
            {
                id:0,
                points:"",
                isLast:false,
            }
        ],
        axisLabelPoints:[],

        points:"",

    }),
    computed: {


    },
    mounted:function() {
        //this.updateDrawData();
      this.refresh()
    },
    created:function() {
    },
    methods: {

        setupConditions(){

        },

        refresh(){

          this.stats.splice(0)

          this.values.forEach(rec =>{
              let d = {
                "label": rec.evaluate_item_name,
                "value": rec.score * (100 / 5.0),
                "id": rec.evaluate_item_cd,
              };
              this.stats.push(d)
          });

          this.updateDrawData()
        },

        updateDrawData(){

            const circle = this.circle;
            const stats = this.stats;
            const total = stats.length

            // 枠の描画ポイントを取得する
            let stepCount = 5.0;
            let step = circle.cx / stepCount;
            this.baseFrame.splice(0);
            for (let i = 0; i < stepCount; i++) {
                let v = step * (i + 1);

                let a = stats.map((stat, i) => {
                    const point = this.valueToPoint(v, i, total);
                    return point.x + ',' + point.y;
                }).join(' ');

                this.baseFrame.push({
                    id:i,
                    points: a,
                    isLast: i === (stepCount -1),
                });

            }

            // 値の描画ポイントを取得する
            this.points = stats.map((stat, i) => {
                const point = this.valueToPoint(stat.value, i, total);
                return point.x + ',' + point.y;
            }).join(' ');


            // Axisラベルの描画位置を取得する
            this.axisLabelPoints = stats.map((stat, i) => {
                const point = this.valueToPoint(100 + 10, i, total);
                return {
                    x: point.x,
                    y: point.y,
                    label:stat.label,
                    id:stat.id,
                }
            });

        },

        valueToPoint(value, index, total){

            let circle = this.circle;

            let x = 0
            let y = -value * circle.r / 100.0;

            let angle = Math.PI * 2 / total * index

            let cos = Math.cos(angle)
            let sin = Math.sin(angle)

            let tx = x * cos - y * sin + circle.cx
            let ty = x * sin + y * cos + circle.cy

            return {
                x: tx,
                y: ty
            }

        },
    },

}
</script>
<style lang="scss" scoped>

    #radar-base{

        polygon {
            fill:none;
            stroke: #7ac5e9;
            stroke-width:1px;
            stroke-dasharray:3px;
        }

        polygon.last {
            fill:none;
            stroke: #999;
            stroke-width:2px;
            stroke-dasharray:none;
        }

        circle {
            fill: transparent;
            stroke: #999;
        }


    }


    #radar-pentagon {
        polygon {
            fill: none;
            //opacity: .75;
            stroke: #999;
        }
        text {
            font-family: Helvetica Neue, Arial, sans-serif;
            font-size: 10px;
            fill: #666;
        }
    }


</style>